(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  /* BR added on the Main nav */
  /*document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth < 1280) {
      document.documentElement.classList.add('nav-ready');
      return;
    }

    document.querySelectorAll('.main-nav__item--primary').forEach(a => {
      a.childNodes.forEach(node => {
        if (node.nodeType === 3) {
          const text = node.textContent.trim();
          if (!text) return;

          let before, after;

          if (text.includes('&')) {
            const idx = text.indexOf('&') + 1;
            before = text.substring(0, idx);
            after = text.substring(idx).trim();
          } else {
            const parts = text.split(' ');
            before = parts[0];
            after = parts.slice(1).join(' ');
          }

          if (after) {
            node.textContent = before;
            const br = document.createElement('br');
            const afterNode = document.createTextNode(after);
            node.after(br);
            br.after(afterNode);
          }
        }
      });
    });

    // Reveal nav once manipulation is done
    document.documentElement.classList.add('nav-ready');
  });*/

  } catch(e) { console.error(e); }
})();
})();
